<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        :color="color"
        @click="$emit('click')"
    >
        <line class="a" x1="12" y1="0.75" x2="12" y2="4.5" />

        <line class="a" x1="0.75" y1="12" x2="4.5" y2="12" />

        <line class="a" x1="12" y1="23.25" x2="12" y2="19.5" />

        <line class="a" x1="23.25" y1="12" x2="19.5" y2="12" />

        <line class="a" x1="2.25" y1="2.25" x2="21.75" y2="21.75" />

        <path class="a" d="M18.983,14.741A7.5,7.5,0,0,0,9.259,5.017" />

        <path class="a" d="M5.017,9.259a7.5,7.5,0,0,0,9.724,9.724" />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'LocationTargetOffIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
        color: {
            type: String,
            default: '#000',
        },
    },
}
</script>

<style lang="scss" scoped>
.a {
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
}
</style>
